module.exports = __webpack_public_path__ + "static/media/SlatePro-Medium.ddb97da8.woff";